import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectors as materialsSelectors } from '../../../../../store/materials';

import * as classRoomSelectors from '../../../../../../core/selectors/classroom';
import MaterialTab from './MaterialsTab';

const isChangingClassRoom = createSelector(
  classRoomSelectors.classRoom,
  (spaceMeta) => spaceMeta.isChangingClassRoom
);

const shouldDisplaySectionsLoader = createSelector(
  materialsSelectors.hasFetchedSections,
  materialsSelectors.isFetchingSections,
  isChangingClassRoom,
  (hasFetched, isFetching, isChangingSpace) =>
    !hasFetched || isFetching || isChangingSpace
);

const mapStateToProps = (state) => ({
  shouldDisplaySectionsLoader: shouldDisplaySectionsLoader(state),
});

const MaterialTabContainer = connect(mapStateToProps)(MaterialTab);

export default MaterialTabContainer;
